const getRedirectUrl = function(redirectUrl) {
  if (redirectUrl.indexOf('127.0.0.1:85') > -1) {
    redirectUrl = redirectUrl.replace('127.0.0.1:85', location.host);
  }
  return redirectUrl;
};

export { getRedirectUrl };
